export const th = {
    "n1": "หน้าแร...",
    "n2": "สั่งซื้อ",
    "n3": "การทำธุรกรรม",
    "n4": "ที...",
    "n5": "ของฉัน",
    "t1": "มีบางอย่างผิดพลา...",
    "t2": "คัดลอกเรียบร้อยแล้ว",
    "t3": "กรุณากรอกข้อมูลให้ครบถ้ว...",
    "t4": "กำลังโหล...?..",
    "t5": "เข้าสู่ระบบสำเร็...",
    "t6": "คะแนนต้องมากกว่า 3 จึงจะส่งได...",
    "t7": "ส่งสำเร็จแล้...",
    "t8": "ยอดคงเหลือไม่เพียงพอ ไม่สามารถรับได...",
    "t9": "การส่งล้มเหล...",
    "t10": "กรุณาผูกที่อยู่การถอนเงินก่อ...",
    "t11": "ที่อยู่ถูกผูกไว้โปรดติดต่อฝ่ายบริการลูกค้าเพื่อแก้ไ...",
    "t12": "การปรับเปลี่ยนสำเร็...",
    "t13": "การแก้ไขล้มเหล...",
    "t14": "โปรดติดต่อฝ่ายบริการลูกค้าเพื่อเปลี่ยนรหัสผ่านของคุณ",
    "t15": "ข้อผิดพลาดรูปแบบรหัสผ่าน",
    "t16": "ถอนเงินสำเร็...",
    "t17": "จำนวนเงินสูงสุดที่สามารถถอนออกได...",
    "t18": "การถอนขั้นต่...",
    "t19": "รหัสผ่านสองตัวไม่สอดคล้องกัน",
    "t20": "เคล็ดลั...",
    "t21": "ไม่สามารถกระโดดได้ในขณะนี้",
    "t22": "ข้อผิดพลาดรูปแบบรหัสผ่าน",
    "t23": "การลงทะเบียนสำเร็...",
    "t24": "กรุณากรอกรหัสพื้นที่",
    "t25": "ไม่มีอีกแล้ว",
    "l1": "ภาษา",
    "l2": "กรุณากรอกหมายเลขบัญช...",
    "l3": "กรุณากรอกรหัสผ่า...",
    "l4": "จำไว...",
    "l5": "เข้าสู่ระบบ",
    "l6": "ไปลงทะเบียน",
    "l7": "ไม่มีบัญชี",
    "l8": "หมายเลขโทรศัพท์มือถือ",
    "l9": "ชื่อเล่...",
    "l10": "รหัสผ่าน",
    "l11": "ยืนยันรหัสผ่าน",
    "l12": "รหัสคำเชิ...",
    "l13": "ลงทะเบียน",
    "l14": "มีบัญชีอยู่แล้...",
    "l15": "ไปที่เข้าสู่ระบบ",
    "l16": "กรุณากรอกรหัสผ่า...?6-16 หลัก",
    "bz1": "ช่วยด้วย",
    "bz2": "คำถามที่พบบ่อย",
    "bz3": "กฎการซื้อขาย",
    "bz4": "วิธีการถอนเงิ...",
    "bz5": "วิธีการเติมเงิ...",
    "bz6": "1. Amazon Review RoBoT คืออะไ...",
    "bz7": "Amazon Review RoBoT คือบริษัทส่งเสริมการตลาดที่ช่วยให้ผู้ค้าร้านค้าออนไลน์ของ Amazon Review RoBoT ทั่วโลกได้รับคำสั่งซื้อเพิ่มขึ้น และเพิ่มข้อมูลการเรียกดูร้านค้าออนไลน์ขอ...?Amazon Review RoBoT เรามุ่งมั่นที่จะสร้างโมเดลการตลาดและการส่งเสริมการขายที่ทำกำไรจากบุคคลที่สามระหว่าง Amazon Review RoBoT ผู้ค้า และผู้บริโภค เมื่อรวมกับเทคโนโลยีบล็อคเชน P2P ล่าสุด ผู้บริโภคและผู้ค้าจะเชื่อมต่อกันอย่างรวดเร็วผ่า...?USDT (TRC20, ERC20) ผู้ใช้ที่ลงทะเบียนสามารถรับค่าคอมมิชชั่นจากการสั่งซื้อ ในขณะที่ร้านค้าสามารถเพิ่มข้อมูลยอดขายของร้านค้าได...?มันเป็นรูปแบบกำไรล่าสุดในรูปแบบอินเทอร์เน็ตบล็อกเชน!",
    "bz8": "2. Amazon Review RoBoT ทำงานอย่างไร",
    "bz9": "ความคิดเห็นรายวันจาก Amazon Review RoBoT แสดงให้เห็นว่าผลิตภัณฑ์ที่ต้องมีการปรับปรุงนั้นขายใน Amazon Review RoBoT ผู้ใช้เพียงแค่คลิกคำสั่งซื้ออย่างง่ายดา...?และระบบจะสร้างการสมัครรับคำสั่งซื้อโดยอัตโนมัต...?ผู้ใช้ชำระเงินตามจำนวนคำสั่งซื้อผ่า...?blockchain USDT และรับค่าคอมมิชชั่นรายวั...",
    "bz10": "3.เหตุใดราคาในสกุลเงินเดียวกันจึงแตกต่างกันในการทำธุรกรรมสองรายกา...?",
    "bz11": "ความแตกต่างของราคาเกิดจากปัจจัยทั้งหมดที่ไม่เอื้อต่อการหมุนเวียนของสกุลเงินอย่างเสร...?รวมถึงความเร็วของการโอนสกุลเงิ...?เงื่อนไขของเครือข่าย ข้อจำกัดในการเข้าถึงสกุลเงิ...?การรับรู้สกุลเงินโดยผู้คนในภูมิภาคต่าง...?และแม้แต่ประเภทของคู่การซื้อขายที่ให้บริการโดยการแลกเปลี่ยน ธุรกรร...?ฯล...?ดังนั้...?สกุลเงินเดียวกันจึงอาจมีความแตกต่างของราคาในธุรกรรมที่แตกต่างกั...",
    "bz12": "4. กำไรจากการลงทุ...?",
    "bz13": "ยิ่งราคาของสินค้าที่คุณได้รับสูงเท่าไ...?กำไรที่คุณได้รับจากการสั่งซื้อก็จะยิ่งสูงขึ้นเท่านั้...?ในเวลาเดียวกั...?Amazon Review RoBoT จะสุ่มกระจายคำสั่งคอมมิชชันจำนวนมา...",
    "bz14": "ทุกๆ วั...?ระบบจะสร้างและกระจายคำสั่งซื้อผลิตภัณฑ...?60 รายการให้กับผู้ใช้โดยอัตโนมัติ ผู้ใช้ชำระเงินสำหรับแต่ละคำสั่งซื้อผ่าน USDT และรับค่าคอมมิชชัน 0.6% คำสั่งคอมมิชชั่นจำนวนมากจะถูกสุ่มมอบหมาย",
    "bz15": "USDT สามารถถอนออกได้หลังจาก 60 คำสั่ง (หากไม่คร...?60 ออเดอร์ ระบบจะหยุดอัตโนมัติจนกว่าจะมีออเดอร์คงเหลือของวัน)",
    "bz16": "แต่ละบัญชีสามารถผูกกับบัญช...?USDT ได้เพียงบัญชีเดียวเท่านั้...?หากเกิดข้อผิดพลาดโปรดติดต่อฝ่ายบริการลูกค้...",
    "bz17": "หลังจากส่งคำสั่งซื้อรายวันเสร็จสิ้นแล้วคุณสามารถถอนเงินได้ตามปกต...?เงินจะมาถึงภายใ...?24 ชั่วโมงหลังจากเริ่มถอนเงิ...?และไม่มีข้อจำกัดในการถอนเงิ...",
    "bz18": "ก่อนเติมเงิ...?โปรดผูกที่อยู่การถอนเงินของคุ...?(รองรับ TRC-20) ที่อยู...?USDT คุณสามารถคลิกที่เติมเงินบนแอพหรือหน้าเว็บแล้วเลือกบล็อคเชน (TRC-20) ที่คุณใช้เติมเงิ...",
    "bz19": "ห้ามทำการเติมเงินร่วมกัน โอนเงินผ่านธนาคา...?โอนเงิ...?ฯล...?ระหว่างบัญชีที่เกี่ยวข้อ...?พฤติกรรมนี้ถูกสงสัยว่าเป็นการแย่งชิงคำสั่งที่เป็นอันตราย หากพบพฤติกรรมดังกล่า...?บัญชีจะถูกแบ...",
    "ty1": "ตกลง",
    "ty2": "ยกเลิ...",
    "ty3": "ส่...",
    "ty4": "ที่อยู...?TRC20",
    "ty5": "ที่อยู...?ERC20",
    "s1": "รายได้สะสม",
    "s2": "บริการ",
    "s3": "เกี่ยวกับเรา",
    "s4": "ช่วยด้วย",
    "s5": "พันธมิตร",
    "s6": "บริการของฉัน",
    "d1": "ไม่เสร็จ",
    "d2": "เสร็จสิ้น",
    "d3": "ยังไม่มีข้อมูล",
    "d4": "หมายเลขคำสั่งซื้อ",
    "d5": "ชั่วโมงการซื้อขา...",
    "d6": "จำนว...",
    "d7": "จำนวนงานปัจจุบัน",
    "d8": "ผลตอบแทนที่คาดหวัง",
    "d9": "ยังต้องการ",
    "d10": "เรตติ้ง",
    "j1": "ยอดเงินในบัญชี",
    "j2": "การแนะนำการซื้อขาย",
    "j3": "Amazon Review RoBoT ใช้คำติชมจาก Amazon Review RoBoT ทุกวันเพื่อแสดงผลิตภัณฑ์ที่ขายโดย Amazon Review RoBoT ที่ต้องมีการปรับปรุง ผู้ใช้เพียงแค่คลิกคำสั่งซื้...?จากนั้นระบบจะสร้างลายเซ็นคำสั่งซื้อโดยอัตโนมัต...?ผู้ใช้ชำระเงินตามจำนวนคำสั่งซื้อผ่านบล็อกเชน USDT และสามารถรับค่าคอมมิชชันมากกว่...?0.6% ในแต่ละครั้ง และระบบจะสุ่มกระจายคำสั่งซื้อรางวัลจำนวนมา...",
    "j4": "เริ่มการจับคู...",
    "j5": "รายได้วันนี้",
    "j6": "เสร็จสิ้น",
    "j7": "จำนวนงานทั้งหม...",
    "td1": "ความสมดุ...",
    "td2": "ค่าคอมมิชชัน",
    "td3": "รั...",
    "td4": "จำนวนคนทั้งหมด",
    "td5": "ผู้ใช้",
    "td6": "มีส่วนร่วม",
    "td7": "ปริมาณ",
    "td8": "สถาน...",
    "g1": "ถอนเงินส...",
    "g2": "เติมเงิ...",
    "g3": "ชวนเพื่อ...",
    "g4": "เชิญเลย",
    "g5": "สำหรับทุกๆ ผลกำไรที่เพื่อนของคุณได้รับหลังจากลงทะเบียน คุณจะได้รับค่าคอมมิชชั่นที่เกี่ยวข้อ...",
    "g6": "ข้อมูลส่วนบุคค...",
    "g7": "รายละเอียดกองทุน",
    "g8": "บันทึกการเติมเงิ...",
    "g9": "บันทึกการถอนเงิ...",
    "g10": "ภาษา",
    "g11": "ออกจากระบบ",
    "g12": "คุณแน่ใจหรือไม่ว่าต้องการออกจากระบ...?",
    "yh1": "ข้อมูลผู้ใช้",
    "yh2": "ปรับเปลี่ยน",
    "yh3": "การตั้งค่า",
    "yh4": "โทรศัพท์",
    "yh6": "รหัสผ่านเดิ...",
    "yh7": "รหัสผ่านใหม่",
    "mx1": "การรวบรวมค่าคอมมิชชั...",
    "mx2": "รายได้",
    "mx3": "การถอนเงินถูกปฏิเสธ",
    "mx4": "เวล...",
    "mx5": "เติมเงินสำเร็...",
    "mx6": "ถูกปฏิเสธ",
    "mx7": "รอดำเนินการ",
    "mx8": "ที่อยู่การถอนเงิ...",
    "mx9": "ยอดคงเหลือที่มีอยู...",
    "mx10": "มาถึงจริ...",
    "mx11": "กรุณากรอกจำนวนเงินที่ถอ...",
    "cz1": "ที่อยู่การฝากเงินรองรับเฉพาะ ERC20 และจำนวนเงินฝากขั้นต่ำคือ 20USDT",
    "cz2": "คัดลอก",
    "cz3": "การเลือกสกุลเงินของ Fiat",
    "cz4": "จ่าย",
    "cz5": "ที่อยู่การฝากเงินรองรับเฉพาะ TRC20-USDT และจำนวนเงินฝากขั้นต่ำคือ 20USDT",
    "cz6": "ที่อยู่การฝากเงินรองรับเฉพาะ ERC20 และจำนวนเงินฝากขั้นต่ำคือ 20USDT",
    "cz10": "ที่อยู่การฝากรองรับเฉพาะ BTC เท่านั้...",
    "qy1": "รหัสพื้นที...",
    "yq1": "ชวนเพื่อ...",
    "yq2": "รหัสคำเชิ...",
    "yq3": "เชิญเพื่อนและเพลิดเพลินไปกับสิทธิประโยชน์มากมาย",
    "yq4": "ไปเชิญได้เลย",
    "new1": "วิธีการชำระเงิ...",
    "zf1": "วิธีการเติมเงิ...",
    "zf2": "โปรดเลือกวิธีการเติมเงิ...",
    "zf3": "การซื้อขายสกุลเงิ...",
    "zf4": "เครือข่ายการค้า",
    "zf5": "ไปค้าขาย",
    "zf6": "คัดลอกเรียบร้อยแล้ว",
    "zf7": "การซื้อขายสกุลเงิ...",
    "zf8": "กรุณาใช้",
    "zf9": "โอนเงินไปยังที่อยู่ด้านล่างเพื่อทำการเติมเงินให้เสร็จสิ้น",
    "zf10": "สกุลเงินของธุรกรร...",
    "zf11": "คัดลอก",
    "zf12": "กรุณาตรวจสอบที่อยู่อย่างระมัดระวัง หากคุณโอนไม่ถูกต้อ...?คุณจะไม่สามารถเรียกคืนได้",
    "zf13": "เวลามาถึง",
    "zf14": "ประมาณ 1~5 นาที",
    "zf15": "จำนวนการเติมเงินขั้นต่ำ",
    "a1": "ศูนย์การตลาดร้านค้...",
    "a2": "ศูนย์การตลาดร้านค้...?Amazon Market Robot เป็นส่วนใหม่ล่าสุดที่ออกแบบมาเพื่อช่วยให้ผู้ค้าเพิ่มยอดขายและอัตราการชมเชยผลิตภัณฑ์ของตนได้อย่างรวดเร็วในระยะเวลาอันสั้น ซึ่งจะช่วยเพิ่มน้ำหนักของผลิตภัณฑ์และเพิ่มการมองเห็นผลิตภัณฑ์ต่อไ...?ผู้ใช้ช่วยเหลือร้านค้าโดยทำภารกิจต่าง ...?ให้สำเร็จและรับรางวัลที่เกี่ยวข้อ...?ดังนั้นจึงบรรลุสถานการณ์ที่ทั้งสองฝ่ายได้ประโยชน์ทั้งสองฝ่าย",
    "a3": "ปัจจุบัน ระบบมีผู้ใช้ 30 ล้านรายและผู้ค้า 5 ล้านรา...?และจำนวนผลิตภัณฑ์ที่โปรโมตบนแพลตฟอร์มทุกวันสูงถึ...?70 ล้านรา...?สินค้าของร้านค้าบางรายเพิ่มยอดขายในร้านถึ...?60% โดยเชื่อมต่อกับระบบศูนย์การตลา...?และระบบศูนย์การตลาดเพียงคลิกคำสั่งซื้อ และระบบศูนย์การตลาดจะสร้างลายเซ็นคำสั่งซื้อโดยอัตโนมัต...?หลังจากที่ผู้ใช้ชำระเงินตามจำนวนคำสั่งซื้อล่วงหน้...?ธุรกรรมเสมือนจะเสร็จสมบูรณ...?และเงินจะถูกส่งคืนไปยังบัญชีผู้ใช้ทันท...?สามารถรับค่าคอมมิชชั่นเพิ่มเติมได้มากกว่...?0.6% ในแต่ละครั้ง ระบบจะสุ่มจัดสรรคำสั่งซื้อรางวัลจำนวนมากเพื่อเพิ่มค่าคอมมิชชั่นของผู้ใช้",
    "a4": "Amazon Market Robot ให้ความสำคัญอย่างยิ่งต่อความต้องการของผู้ใช้และผู้ค้...?และยังคงเพิ่มประสิทธิภาพและปรับปรุงระบบศูนย์การตลาดอย่างต่อเนื่อ...",
    "kf1": "บริการออนไลน์",
    "kf2": "บริการถอนด้วยตนเอง",
    "kf3": "คลิกที่นี่เพื่อติดต่อบริการถอนด้วยตนเอง",
    "kf4": "บริการเติมเงินด้วยตนเอง",
    "kf5": "คลิกที่นี่เพื่อติดต่อบริการเติมเงินด้วยตนเอง",
    "zf16": "สำหรับการทำธุรกรรมผ่านบัตรธนาคาร กรุณาติดต่อฝ่ายบริการลูกค้า",
    "zf17": "ติดต่อฝ่ายบริการลูกค้า",
    "kf1": "Online Service",
    "kf2": "Manual Withdrawal Service",
    "kf3": "Click here to contact manual withdrawal service",
    "kf4": "Manual Recharge Service",
    "kf5": "Click here to contact manual recharge service",
    "zf16": "Please contact customer service for bank card transactions",
    "zf17": "Contact customer service",
    "kf1": "Online Service",
    "kf2": "Manual Withdrawal Service",
    "kf3": "Click here to contact manual withdrawal service",
    "kf4": "Manual Recharge Service",
    "kf5": "Click here to contact manual recharge service",
    "zf16": "Please contact customer service for bank card transactions",
    "zf17": "Contact customer service"
}
